import React from 'react';
import { Col, Image, Row } from 'react-bootstrap';
import HouseFeatures from './HouseFeatures';
import HouseMainImage from './house/HouseMainImage';

const HouseHeader = ({ house }) => {
  return (
    <Row className="align-items-center mb-4">
      <Col xs="auto">
        <div style={{ width: '120px', height: '120px' }}>
          <HouseMainImage house={house} />
        </div>
      </Col>
      <Col>
        <h5 className="mb-2">{house.name}</h5>
        <HouseFeatures house={house} />
      </Col>
    </Row>
  );
};

export default HouseHeader;
